const actionName = (name, stage) => `${name}:${stage}`;
export const successActionName = name => actionName(name, 'success');
const STAGES = ['request', 'success', 'error'];
export const createRequestActionNames = name =>
  STAGES.map(stage => actionName(name, stage));

/**
 * This creates an object with three named functions: request, success and error
 */
export default function createRequestActions(name) {
  return STAGES.reduce((actions, stage) => {
    actions[stage] = payload => ({
      type: actionName(name, stage),
      payload,
      [stage]: true,
    });
    return actions;
  }, {});
}
